import React from 'react';
import { Button } from 'react-bootstrap';
import { Icon } from './icon';

export const ButtonIcon: React.FC<React.PropsWithChildren<any>> = ({
  onClick = () => {},
  style,
  icon,
  placement = 'left',
  tooltip,
  dataCy,
  disabled = false,
  href,
  className = 'p-0 ms-1',
  size,
  variant = 'link',
  color = 'var(--primary)',
}) => {
  return (
    <Button variant={variant} className={className} onClick={onClick} data-cy={dataCy} href={href} disabled={disabled}>
      <Icon style={style} icon={icon} tooltip={tooltip} placement={placement} size={size} color={color} />
    </Button>
  );
};
